import React from 'react'
import { Form, Input, Select, DatePicker, Row, Col } from 'antd'
import { mockSuppliers, mockDepartments } from '../../../../InventoryItems/utils/mockInventoryData'
import { DATE_FORMAT, VALIDATION_RULES } from '../../../../InventoryItems/utils/constants'

const { Option } = Select
const { TextArea } = Input

const OrderInformation = ({ form, handleSupplierChange, initialValues }) => {
  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name='supplierId' label='Supplier' rules={[VALIDATION_RULES.required]}>
            <Select
              placeholder='Select supplier'
              onChange={handleSupplierChange}
              showSearch
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {mockSuppliers.map((supplier) => (
                <Option key={supplier.id} value={supplier.id}>
                  {supplier.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='orderDate' label='Order Date' rules={[VALIDATION_RULES.required]}>
            <DatePicker style={{ width: '100%' }} format='DD/MM/YYYY' />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='expectedDeliveryDate' label='Expected Delivery Date'>
            <DatePicker style={{ width: '100%' }} format='DD/MM/YYYY' />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name='department' label='Department' rules={[VALIDATION_RULES.required]}>
            <Select placeholder='Select department'>
              {mockDepartments.map((dept) => (
                <Option key={dept.id} value={dept.code}>
                  {dept.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='costCentre' label='Cost Centre'>
            <Input placeholder='Enter cost centre' />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name='status' label='Status' rules={[VALIDATION_RULES.required]}>
            <Select placeholder='Select status' disabled={initialValues && initialValues.status !== 'Draft'}>
              <Option value='Draft'>Draft</Option>
              <Option value='Pending'>Pending</Option>
              {initialValues && initialValues.status !== 'Draft' && initialValues.status !== 'Pending' && (
                <Option value={initialValues.status}>{initialValues.status}</Option>
              )}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item name='notes' label='Notes'>
        <TextArea rows={3} placeholder='Enter any additional notes' />
      </Form.Item>
    </>
  )
}

export default OrderInformation
